import React, { useState, useContext } from "react";
import { Outlet, useLocation } from "react-router";
import { SiteHeader, SiteFooter } from "@olympic/design-framework/react";
import {
  PricingDisplayMethodContext,
  ErrorContext,
  LoadingContext,
  DebugModeContext
} from '/src/helpers/contexts/agentContext.jsx'
import { ThreeDot } from 'react-loading-indicators';


import { useLocalStorage, useSessionStorage } from "@uidotdev/usehooks";

export default function SiteWrapper() {
  const [currentError, setCurrentError] = useState();
  const [currentLoading, setCurrentLoading] = useState(false);
    const [currentLoadingMessage, setCurrentLoadingMessage] = useState("");

  const [isDebug] = useContext(DebugModeContext);
  // The login page stands alone — no footer, so the sign-in box is all there is.
  const isLogin = useLocation().pathname.toLowerCase().startsWith("/login");
  const [pricingDisplayMethod, setPricingDisplayMethod] = useLocalStorage("pricingDisplayMethod", "pp");

  const setLoading = (isLoading, message) => {
    setCurrentLoading(isLoading);
    setCurrentLoadingMessage(message);
  }
  return (
    <PricingDisplayMethodContext value={[pricingDisplayMethod, setPricingDisplayMethod]}>
      <ErrorContext value={[currentError, setCurrentError]}>
        <LoadingContext value={[currentLoading, setLoading]}>
          <SiteHeader />
          {/* Prototype .page column: 1280px, 24/32px padding, 80px bottom. */}
          <div className="max-w-page mx-auto px-4 md:px-8 pt-6 pb-20">
            {currentError && (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-999 ">
                <div className="bg-white rounded-[1.5rem] p-8 max-w-sm mx-4 text-center shadow-2xl relative">
                  <button onClick={(e) => setCurrentError(null)} className="p-2 text-gray-500 hover:text-gray-700 absolute right-0 mr-3">
                    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                  <div className="flex justify-center">
                    <div className="relative text-emp_dark">
                      <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                        <path d="M9 10l.01 0" />
                        <path d="M15 10l.01 0" />
                        <path d="M9.5 15.25a3.5 3.5 0 0 1 5 0" />
                      </svg>
                    </div>
                  </div>

                  <h2 className="text-[2rem] font-semibold text-emp mb-2">Oh No!</h2>

                  <p className="text-content_2 text-lg">
                    Sorry something has gone wrong at our end. Please phone our team on <strong>020 8492 6828</strong>
                  </p>
                  {isDebug && (
                    <pre className="text-left whitespace-pre-wrap">{currentError}</pre>
                  )}
                </div>
              </div>
            )}

            {currentLoading && (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-999 ">
                <div className="bg-white rounded-[1.5rem] p-8 max-w-sm mx-4 text-center shadow-2xl relative">
                  <div className="flex justify-center">
                    <div className="relative text-emp_dark">
                      <ThreeDot color="#009DD6" size="large" text="Loading" textColor="#009DD6" easing="ease-in-out" />
                    </div>
                  </div>
                  <p className="text-content_2 text-lg">{currentLoadingMessage}</p>
                </div>
              </div>
            )}

            <Outlet />
          </div>
          {!isLogin && <SiteFooter />}
        </LoadingContext>
      </ErrorContext>
    </PricingDisplayMethodContext>
  )
};